// React Imports
import { useEffect, useState } from "react";

// Router Imports
import { useNavigate } from "react-router-dom";

// Redux Imports
import { useDispatch } from "react-redux";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

// Utils Imports
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

// Component Imports
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../_utils/FormatAmount/FormatAmount";

const ReimbursementRequestMultiApprovalSuccess = () => {
  // 1️⃣ useNavigate & useDispatch
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 2️⃣ useState
  const [successPageData, setsuccessPageData] = useState([]);
  const [successPageID, setsuccessPageID] = useState([]);
  const [approvedTransactions, setApprovedTransactions] = useState([]);

  // 3️⃣ Callback / Handler functions
  const goToDashboard = () => {
    navigate("/reimbursement_transaction_dashboard", {
      replace: true,
    });
  };

  const approveMoreTransactions = () => {
    navigate(
      "/reimbursement_transaction_dashboard/reimbursement_request_multi_select",
      {
        replace: true,
      },
    );
  };

  const buttonRows = [
    [
      {
        btnText: "Approve requests",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: approveMoreTransactions,
        fullWidthRequired: true,
        hoverOption: "black",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];

  // 4️⃣ useEffect
  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementRequestTxnData"),
    );

    if (storedSelectedApproval) {
      const transactions =
        storedSelectedApproval?.selectedSendTransactions || [];
      const approved = transactions.filter(
        (transaction) => transaction.lifecycle_status === "approved",
      );
      setsuccessPageData(storedSelectedApproval?.selectedSendTransactions);
      setApprovedTransactions(approved);
      setsuccessPageID(storedSelectedApproval.selectedTransactions);
    } else {
      setsuccessPageData([]);
      setsuccessPageID([]);
    }
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <>
      <StatusContainer
        status="success"
        title={
          successPageData.length &&
          "Requests approved and transactions created successfully."
        }
        buttonRows={buttonRows}
      >
        {approvedTransactions.length > GlobalConfiguration.lengthCheckZero && (
          <TabsWeapperSection
            title={`Approved and created  - ${successPageID.length}`}
          >
            <div className="flex flex-col">
              {successPageData.map((account, i) => (
                <InfoCard
                  showRowDivider={true}
                  rowBorderColor={"var(--positive-bg)"}
                  key={account?.request_id || i}
                  bgColor="var(--positive-card)"
                  hoverable="black"
                  onClick={() =>
                    navigate(
                      `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${account?.request_id}`,
                      {
                        replace: true,
                      },
                    )
                  }
                  rows={[
                    {
                      rightIcon: true,
                      leftTitle: `INR ${FormatAmount({ price: account?.reimbursement_amount })}`,
                      leftTextFontWeight: "semibold",
                      leftSubTitle: "Amount",
                      onClick: () =>
                        navigate(
                          `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${account?.request_id}`,
                          {
                            replace: true,
                          },
                        ),
                    },
                    {
                      leftTitle: account?.beneficiary_account_name,
                      leftSubTitle: "Account name",
                      onClick: () =>
                        navigate(
                          `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${account?.request_id}`,
                          {
                            replace: true,
                          },
                        ),
                    },
                  ]}
                />
              ))}
            </div>
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </>
  );
};

export default ReimbursementRequestMultiApprovalSuccess;
